import { render, staticRenderFns } from "./household.vue?vue&type=template&id=47eb964e&scoped=true"
import script from "./household.vue?vue&type=script&lang=js"
export * from "./household.vue?vue&type=script&lang=js"
import style0 from "./household.vue?vue&type=style&index=0&id=47eb964e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47eb964e",
  null
  
)

export default component.exports